import * as React from "react";
import Slider from "react-slick";
import Provider from "./Provider";
import Location from "./Location";
import OpenScheduleButton from "./OpenScheduleButton";

class SelectedMapPinListing extends React.Component {
    constructor(props) {
        super(props);
        this.sliderSettings = {
            centerMode: false,
            infinite: false,
            centerPadding: '0px',
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 8000,
            pauseOnHover: true,
            cssEase: 'linear',
            focusOnSelect: true,
            responsive: [{ breakpoint: 768, settings: { slidesToShow: 1 } }]
        };
    }

    componentDidUpdate() {
        if (this.slider) {
            this.slider.slickGoTo(0);
        }
    }

    render() {
        const { selectedLocation, tabIndex, toggleOverlay, isOpen, isVaccineSearch, onlineSchedulingEnabled, buttonText, translate, t } = this.props;
        const group = selectedLocation.group;
        const apptTimesAmount = selectedLocation.count === 1 ? 5 : 3;

        const providersMarkup = group
            .filter(g => g.type === 'provider')
            .map((p, i) => <Provider isProviderMapPinView={true} providerData={p.data} buttonText={buttonText} key={i} apptTimesAmount={apptTimesAmount} locationId={p.locationId} isVaccineSearch={isVaccineSearch} showProviderDetails onlineSchedulingEnabled={onlineSchedulingEnabled} translate={translate} t={t} />);

        const locationsMarkup = group
            .filter(g => g.type === 'location')
            .map((l, i) => <Location locationData={l.data} key={i} buttonText={buttonText} appliedRulesLoc={this.props.appliedRulesLoc} translate={translate} t={t} />);

        return (
            <div className={"selected-map-card" + (isOpen ? "" : " hidden")}>
                <div className="overlay-close-btn" onClick={() => toggleOverlay()}>
                    <a className="icon-close" />
                </div>
                <div className={"selected-map-card--desktop" + (selectedLocation.count === 1 ? ' selectedLocation-one-result' : '')}>
                    {tabIndex === '1'
                        ? <div>
                            <div>{providersMarkup}</div>
                            <div>{locationsMarkup}</div>
                        </div>
                        : <div>
                            <div>{locationsMarkup}</div>
                            <div>{providersMarkup}</div>
                        </div>
                    }
                </div>
                <div className="selected-map-card--mobile">
                    {tabIndex === '1'
                        ? <Slider ref={slider => this.slider = slider} {...this.sliderSettings}>
                            {providersMarkup}
                            {locationsMarkup}
                        </Slider>
                        : <Slider ref={slider => this.slider = slider} {...this.sliderSettings}>
                            {locationsMarkup}
                            {providersMarkup}
                        </Slider>
                    }
                </div>
            </div>
        );
    }
}

export default SelectedMapPinListing;